import { render, staticRenderFns } from "./SoftwareComponentCommandAdd.vue?vue&type=template&id=83b9fe56&scoped=true&"
import script from "./SoftwareComponentCommandAdd.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentCommandAdd.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentCommandAdd.vue?vue&type=style&index=0&id=83b9fe56&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b9fe56",
  null
  
)

export default component.exports